import { each, assign, debounce } from 'lodash'

export default {
  watch: {
    $route: {
      handler () {
        this.__initialize()
      },
      immediate: true
    },

    queryParams () {
      this.__updateQueryStringFilters()
    }
  },

  data () {
    return {
      queryParams: {},
      __initialized: false
    }
  },

  created () {
    this.$watch('filters', debounce(this.__buildQueryParams, this.filtersDebounced === false ? 0 : 800), { deep: true })
  },

  methods: {
    __initialize () {
      if (this.filters === null || this.filters === undefined) {
        throw new Error('Component using "applies-filters" mixin without defining "filters" data prop.')
      }

      if (!this.__initialized) {
        this.filters = this.$options.data().filters
      }

      for (let filter in this.filters) {
        if (
          this.$route.query[filter] !== null &&
          this.$route.query[filter] !== undefined
        ) {
          this.filters[filter] = this.$route.query[filter]
        }
      }

      if (!this.__initialized) {
        this.__buildQueryParams()
      }

      this.__initialized = true
    },

    __buildQueryParams () {
      let queryParams = {}

      each(this.filters, (value, key) => {
        if (value !== null && value !== undefined) {
          queryParams[key] = value
        }
      })

      this.queryParams = queryParams
    },

    __updateQueryStringFilters (replace = true) {
      let query = assign({}, this.$route.query)

      for (let filter in this.filters) {
        if (this.filters[filter]) {
          query[filter] = this.filters[filter]
        } else {
          delete query[filter]
        }
      }

      this.$router[replace ? 'replace' : 'push']({ query, params: { __filters: true } })
    },

    applyQueryFilters () {
      this.__updateQueryStringFilters()

      return Promise.resolve()
    }
  }
}
